import { z } from 'zod';
import { Survey, SurveyDetail, SurveyQuestion, SurveyQuestionAggregate, SurveyResponseGrading, SurveyResponse, SurveyResponseParticipant, SurveyEmbed, } from './survey.js';
export const SurveyResponseEnvelope = z.object({ survey: Survey });
export const SurveyDetailResponseEnvelope = z.object({ survey: SurveyDetail });
export const ArticleSurveyEmbedsResponse = z.object({
    surveys: z.array(SurveyDetail),
});
export const SurveyListResponse = z.object({
    surveys: z.array(Survey),
    total: z.number().int().nonnegative(),
    limit: z.number().int().positive(),
    offset: z.number().int().nonnegative(),
});
export const SurveyQuestionsResponse = z.object({
    questions: z.array(SurveyQuestion),
});
export const SurveySubmitResponse = z.object({
    response: SurveyResponse,
    closed: z.boolean(),
    grading: SurveyResponseGrading.nullable(),
});
export const SurveyResponsesResponse = z.object({
    responses: z.array(SurveyResponse),
    participants: z.array(SurveyResponseParticipant),
    total: z.number().int().nonnegative(),
    limit: z.number().int().positive(),
    offset: z.number().int().nonnegative(),
});
export const SurveyAnalyticsResponse = z.object({
    surveyId: z.string().uuid(),
    totalResponses: z.number().int().nonnegative(),
    averageDurationMs: z.number().nonnegative().nullable(),
    completionRate: z.number().min(0).max(1).nullable(),
    questions: z.array(SurveyQuestionAggregate),
});
export const SurveyEmbedsResponse = z.object({
    embeds: z.array(SurveyEmbed),
});
export const SurveyCapabilitiesResponse = z.object({
    surveysEnabled: z.boolean(),
    conditionalLogicEnabled: z.boolean(),
    fileUploadQuestionEnabled: z.boolean(),
    publicResultsEnabled: z.boolean(),
    iframeEmbedEnabled: z.boolean(),
    coordinationSurveyBridgeEnabled: z.boolean(),
    aiGradingEnabled: z.boolean(),
    canCreate: z.boolean(),
    canCreatePublic: z.boolean(),
    canCreateGroupSurvey: z.boolean(),
    canCreateAnonymousPublic: z.boolean(),
    anonymousGroupMinSize: z.number().int().positive(),
});
//# sourceMappingURL=responses.js.map